var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import { ICCEventBusManager } from '@idp/event-bus';
import * as routables from '@idp/routables';
import { withStore } from '@idp/state-manager';
import { RoutableContainer } from '@idp/routables';
import { Message, Heading } from '@idp/ui-components';
import { MessageType } from '@idp/ui-components/components/atoms/Message/MessageProps';
import { LabelSizes } from '@idp/ui-components/components/atoms/Label/LabelProps';
import CartContainerState from './Cart.container.state';
import { NotificationPanel } from '@idp/ui-components';
import { NotificationType } from '@idp/ui-components/components/panels/NotificationPanel/NotificationPanelProps';
import CartConfigurationContainer from '@idse/cart-ui/components/CartConfigurationContainer/CartConfigurationContainer';
import { StateProvider } from '../../services/state-provider';
import { networker, rejectHTTPErrors, parseJSON } from '../../services/networker';
import getTestId from '@idp/ui-components/utils';
import * as styles from './Cart.container.scss';
import { CatalogDataType, RouteUrlTypes, appShellNameSpace } from '../MainView/MainView.container.props';
import { setTabTitle, setCookie, getPostpaidflowtype, updateDetails, getUrlParamValue, isIncompleteCart, isAtleastOneLineLevelPrePreOrderIndicator, getCartMetaFlowType, isItemOOS, acpVerificationAccessPromo, isEmptyObject, reportPageLoad, getCookie, IsWirelessInCart, isIxpCheckoutFeatureEnabled } from '../../utils/UtilityFunctions';
import { CMS } from '@idp/cms-integration';
import { Types } from '@idp/ui-components/components/atoms/Heading/HeadingProps';
import RetrieveCart from '@idse/cart-ui/components/cards/SaveRetrieveCart/RetrieveCart';
import LoginPanel from '@idse/cart-ui/components/panels/LoginPanel';
import { InfiniteLoader, Banner } from '@idp/ui-components';
import { CMSFeedMap, nameMap } from '../MainView/MainViewMaps';
import SessionTimerModal from '../SessionTimerModal';
import * as cartUiUtils from '@idse/cart-ui/utils/UtilityFunctions';
import * as cartUtils from '@idse/cart-ui/utils/CartUtilFunctions';
import CheckoutApi from '@idse/cart-ui/api/Api';
import CheckoutUiApi from '@idse/checkout-ui/api/Api';
import { CartCoreCms } from './Cart.container.cms';
import { history } from '@idp/routables';
import * as userinteractionEvents from '../UserInteractionFramework/userInteractionSetup';
import { getCampaignIdentifier } from '@sales/campaign-identifier';
import { Alert, IconSvg } from '@idp/duc/components';
import { LinkPositionDataKeysOptions } from '../../services/AnalyticsEvents';
import ReportingGateway from '../../services/ReportingGateway';
// Persistence Cart
import InitializeCart from '@idp/cart-initializer/CartInit';
import FanBanner from './FanBanner';
import CartCheckoutCountDownTimer from './CartCheckoutCountDownTimer';
var CartContainer = /** @class */ (function (_super) {
    __extends(CartContainer, _super);
    function CartContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.bsseSummaryURL = '/msapi/sales/onlinecartorch/v1/cart-details/cartsummary';
        _this.installationOffersURL = '/msapi/serviceavailability/v1/installationDates';
        _this.migrateCartApi = '/msapi/cart/v1/migrateCart';
        _this.initializeCartApi = '/msapi/cart/v1/intializeCart';
        _this.cartRefeshObserver = '';
        _this.checkoutRefreshObserver = '';
        _this.isErrorCode = false;
        _this.errorCode = '0';
        _this.errorMessage = '';
        _this.displayHandholdingLob = ['DTVS', 'IPTV', 'BROADBAND', 'DTVNOW'];
        _this.displayInstallationMsgLob = ['DTVS'];
        _this.closerCouponWirelineLobs = ['DTVS', 'IPTV', 'BROADBAND', 'DTVNOW'];
        _this.closerCouponWirelessLobs = ['WIRELESS'];
        _this.hideRetriveCartButton = true;
        _this.reportingErrorMessage = '';
        _this.getCartInfo = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, ((_b = (_a = this.cApi) === null || _a === void 0 ? void 0 : _a.cartInfo()) === null || _b === void 0 ? void 0 : _b.then(function (cartData) {
                            if (cartData && cartData.content) {
                                cartData = cartData.content;
                                if (cartData.content) {
                                    delete cartData.content;
                                }
                                if (cartData.deviceDetails) {
                                    delete cartData.deviceDetails;
                                }
                                if (cartData && typeof (cartData.cartCouponCode !== 'undefined')) {
                                    cartData.promoCode = cartData.cartCouponCode;
                                    delete cartData.cartCouponCode;
                                }
                                sessionStorage.setItem('CART:cartInfo', JSON.stringify(cartData));
                            }
                        }).catch(function (err) {
                            sessionStorage.setItem('CART:cartInfo', null);
                            console.log('Error in cartInfo response', err);
                        }))];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.stateManager = StateProvider.getStateManagerInstance();
        _this.state = new CartContainerState();
        _this.bindAll();
        _this.cApi = new CheckoutApi();
        _this.checkoutUiApi = new CheckoutUiApi();
        _this.clearCartSessionObject();
        _this.isBBOnlyInCart = cartUiUtils.IsBroadbandInCart();
        return _this;
    }
    CartContainer.getDerivedStateFromError = function () {
        return null;
    };
    CartContainer.prototype.bindAll = function () {
        this.registerToRemoveCart = this.registerToRemoveCart.bind(this);
        this.updateState = this.updateState.bind(this);
        this.startShopping = this.startShopping.bind(this);
        this.getCartHeader = this.getCartHeader.bind(this);
        this.getCartConsole = this.getCartConsole.bind(this);
        this.getHrefUrl = this.getHrefUrl.bind(this);
        this.showCloseButton = this.showCloseButton.bind(this);
        this.onCartEdit = this.onCartEdit.bind(this);
        this.cartSummary = this.cartSummary.bind(this);
        this.retrieveSavedCart = this.retrieveSavedCart.bind(this);
        this.registerTobaseURL = this.registerTobaseURL.bind(this);
        this.setBaseUrlFromCart = this.setBaseUrlFromCart.bind(this);
        this.retriveModalClose = this.retriveModalClose.bind(this);
        this.isPrepaidFlow = this.isPrepaidFlow.bind(this);
        this.setBannerMessages = this.setBannerMessages.bind(this);
        this.getinstallationMessage = this.getinstallationMessage.bind(this);
        this.getBannerContainer = this.getBannerContainer.bind(this);
        this.getCartAddressObj = this.getCartAddressObj.bind(this);
        this.scrolltoTop = this.scrolltoTop.bind(this);
        this.setStartShoppingURL = this.setStartShoppingURL.bind(this);
        this.clearCartSessionObject = this.clearCartSessionObject.bind(this);
        this.setupCloserCouponEvents = this.setupCloserCouponEvents.bind(this);
        this.checkExpressUpFlow = this.checkExpressUpFlow.bind(this);
        this.setUpgradeIntent = this.setUpgradeIntent.bind(this);
        this.onCartSuccessResponse = this.onCartSuccessResponse.bind(this);
        this.renderOfferBanner = this.renderOfferBanner.bind(this);
        this.invokeMigrateCartApi = this.invokeMigrateCartApi.bind(this);
        this.acpAccessPromo = this.acpAccessPromo.bind(this);
        this.eapCancelButtonHandler = this.eapCancelButtonHandler.bind(this);
        this.fetchOnDeviceEncryptToken = this.fetchOnDeviceEncryptToken.bind(this);
        this.renderLoginPanel = this.renderLoginPanel.bind(this);
        this.getCartInfo = this.getCartInfo.bind(this);
    };
    CartContainer.prototype.componentWillMount = function () {
        updateDetails();
        this.setUpgradeIntent();
        routables.resetRoutableComponents();
        setTabTitle('AT&T Shopping Cart');
    };
    CartContainer.prototype.componentWillUnmount = function () {
        routables.resetRoutableComponents();
        ICCEventBusManager.getInstance().deregisterObserver(this.cartRefeshObserver);
        ICCEventBusManager.getInstance().deregisterObserver(this.checkoutRefreshObserver);
        userinteractionEvents.deregisterAllEvents();
    };
    CartContainer.prototype.componentDidMount = function () {
        var _this = this;
        window.scrollTo(0, 0);
        this.registerToRemoveCart();
        this.registerCartRefresh();
        this.registerTobaseURL();
        CMS.route(this, {
            cmsversion: '',
            defaultIntent: nameMap.get(CatalogDataType.CARTCHECKOUT),
            pageName: nameMap.get(CatalogDataType.CARTCHECKOUT),
        }, CMSFeedMap.get(CatalogDataType.CARTCHECKOUT), true, this.stateManager)
            .then(function (res) {
            _this.setState({ allowedCMSGetCall: true });
            if (_this.isPrepaidFlow()) {
                _this.cartSummary();
            }
            else {
                var sessionId = _this.stateManager.get('appShell', 'sid');
                var sessionIdVal = '';
                if (sessionId && sessionId.value) {
                    sessionIdVal = sessionId.value;
                }
                var isFirstNetAuthDoneInCart = cartUtils.isQueryInURL(window.location.href, 'fnStatus=eligible');
                if (isFirstNetAuthDoneInCart) {
                    _this.invokeMigrateCartApi();
                }
                else {
                    var queryparam = 'source=cartui';
                    if (getCookie('acpPromoCookie') && getCookie('acpPromoCookie') === 'true' && !(cartUiUtils.getCartResp())) {
                        queryparam = 'clearACPData=true';
                    }
                    new InitializeCart().initializeCartApi('appShell:csrf-token', sessionIdVal, queryparam)
                        .then(function () {
                        _this.cartSummary();
                    }).catch(function () {
                        _this.cartSummary();
                    });
                }
            }
        })
            .catch(function (err) {
            console.log('   CMS -- catch content not loaded ', err);
        });
    };
    CartContainer.prototype.componentDidUpdate = function () {
        if (document.getElementById('retailstorelinkid')) {
            document.getElementById('retailstorelinkid').onclick = function () {
                var reportingDestinationURL = '/stores/';
                var addData = {
                    additionalData: {
                        linkDestinationUrl: location.origin + reportingDestinationURL,
                        linkName: 'AT&T retail store',
                        linkPosition: LinkPositionDataKeysOptions.BODY,
                    },
                    eventAction: 'linkClick',
                    eventCode: 'Link_Click',
                };
                ReportingGateway.sendReportingEvent(addData);
            };
        }
    };
    // tslint:disable-next-line:no-any
    CartContainer.prototype.componentDidCatch = function (error, info) {
        // Log the error details to splunk
        this.cApi.logToSplunk({
            data: JSON.stringify({ description: 'CTO is shown on Cart Page',
                details: info.componentStack, trace: error.stack }),
            hdrReasonCode: 'CART_JS_ERROR',
            type: 'CTO',
        });
    };
    CartContainer.prototype.isPrepaidFlow = function () {
        var _a;
        var wirelessDetails = this.stateManager.get(appShellNameSpace, 'wirelessDetails');
        return (((_a = wirelessDetails === null || wirelessDetails === void 0 ? void 0 : wirelessDetails.wirelessType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'PREPAID');
    };
    CartContainer.prototype.registerToRemoveCart = function () {
        var _this = this;
        // Now checkout Observer for Cart Removal
        var checkoutObserver = {
            eventHandler: function () { _this.updateState('CHECKOUT'); },
            observerId: ICCEventBusManager.getUUID(),
            serviceName: 'CHECKOUT:emptyCart',
        };
        ICCEventBusManager.getInstance().registerObserver(checkoutObserver);
        var cartObserver = {
            eventHandler: function () { _this.updateState('CART'); },
            observerId: ICCEventBusManager.getUUID(),
            serviceName: 'CART:emptyCart',
        };
        ICCEventBusManager.getInstance().registerObserver(cartObserver);
    };
    CartContainer.prototype.registerTobaseURL = function () {
        var _this = this;
        var checkoutObserver = {
            eventHandler: function () { _this.setBaseUrlFromCart('CART'); },
            observerId: ICCEventBusManager.getUUID(),
            serviceName: 'CART:editLinkUrl',
        };
        ICCEventBusManager.getInstance().registerObserver(checkoutObserver);
    };
    CartContainer.prototype.registerCartRefresh = function () {
        var _this = this;
        this.cartRefeshObserver = ICCEventBusManager.getUUID();
        var cartRefreshObserver = {
            eventHandler: function () { _this.cartSummary(true); },
            observerId: this.cartRefeshObserver,
            serviceName: 'CART:cartUpdate',
        };
        ICCEventBusManager.getInstance().registerObserver(cartRefreshObserver);
        this.checkoutRefreshObserver = ICCEventBusManager.getUUID();
        var checkoutRefreshObserver = {
            eventHandler: function () { _this.cartSummary(true); },
            observerId: this.checkoutRefreshObserver,
            serviceName: 'CHECKOUT:cartUpdate',
        };
        ICCEventBusManager.getInstance().registerObserver(checkoutRefreshObserver);
    };
    CartContainer.prototype.updateState = function (namespace) {
        var emptyCart = this.stateManager.get(namespace, 'emptyCart');
        var curUrl = window.location.href;
        var sessionStartShoppingObj = this.stateManager.get(appShellNameSpace, 'startShoppingURL');
        if (emptyCart) {
            this.setState({ emptyCart: true });
            // Event for LOB team to notify cart is empty
            // this.stateManager.set('emptyCart', { emptyCart: true });
            sessionStorage.removeItem('byodCombinedResponse');
            sessionStorage.removeItem('byodResponses');
            if (!curUrl.includes('buy/checkout') && (sessionStartShoppingObj === null || sessionStartShoppingObj === void 0 ? void 0 : sessionStartShoppingObj.startShoppingURL.includes('buy/broadband'))) {
                this.cartSummary(true);
            }
        }
    };
    CartContainer.prototype.setBaseUrlFromCart = function (namespace) {
        var editLinkUrl = Object.create(this.stateManager.get(namespace, 'editLinkUrl'));
        if (editLinkUrl && editLinkUrl.url) {
            // Event for notify from cart what is edit link in cart summary response
            this.stateManager.set('baseURL', { url: editLinkUrl.url });
        }
    };
    CartContainer.prototype.reloadCartPage = function () {
        if (window && window.location) {
            window.location.reload();
        }
    };
    CartContainer.prototype.retrieveSavedCart = function () {
        this.setState({
            showRetrieveModal: true,
        });
    };
    CartContainer.prototype.startShopping = function () {
        var _a, _b, _c;
        try {
            var sessionStartShoppingObj = this.stateManager.get(appShellNameSpace, 'startShoppingURL');
            var sessionWlsPostpaidUrl = this.stateManager.get(appShellNameSpace, 'wlsPostpaid');
            var startShoppingLink = '';
            if (sessionStartShoppingObj && sessionStartShoppingObj.startShoppingURL && !sessionWlsPostpaidUrl) {
                startShoppingLink = sessionStartShoppingObj.startShoppingURL;
                if ((/buy/i).test(startShoppingLink)) {
                    startShoppingLink = startShoppingLink.split('buy')[1];
                }
            }
            else {
                startShoppingLink = (_c = (_b = (_a = sessionWlsPostpaidUrl === null || sessionWlsPostpaidUrl === void 0 ? void 0 : sessionWlsPostpaidUrl.wlsPostpaid) === null || _a === void 0 ? void 0 : _a.wsceData) === null || _b === void 0 ? void 0 : _b.eapFlow) === null || _c === void 0 ? void 0 : _c.returnURL;
            }
            var reportingDestinationURL = (!sessionWlsPostpaidUrl && startShoppingLink) ? ('/buy' + startShoppingLink) : sessionWlsPostpaidUrl ? startShoppingLink : '/';
            var addData = {
                additionalData: {
                    linkDestinationUrl: location.origin + reportingDestinationURL,
                    linkName: 'Start Shopping',
                    linkPosition: LinkPositionDataKeysOptions.BODY,
                },
                eventAction: 'linkClick',
                eventCode: 'Link_Click',
            };
            ReportingGateway.sendReportingEvent(addData);
            this.stateManager.set('startShopping', { startShopping: true });
            if (startShoppingLink && (startShoppingLink.indexOf('phones') > -1 || startShoppingLink.indexOf('hub') > -1 || startShoppingLink.indexOf('byod') > -1
                || startShoppingLink.indexOf('broadband') > -1 || startShoppingLink.indexOf('line-selection') > -1 || startShoppingLink.indexOf('accessories') > -1)) {
                window.location.href = '/buy' + startShoppingLink;
            }
            else if (startShoppingLink) {
                history.push(startShoppingLink);
            }
            else {
                window.location.assign('/');
            }
        }
        catch (e) {
            console.log(' startShopping click error ', e);
            window.location.assign('/');
        }
    };
    CartContainer.prototype.constructFullUrl = function (path) {
        if (path.includes('http')) {
            return path;
        }
        return window.location.origin + path;
    };
    CartContainer.prototype.updatePriceBarData = function (isReadyToCheckout) {
        var pbData = this.props.pbData;
        if (pbData !== null && pbData !== undefined) {
            pbData.readyToCheckout = isReadyToCheckout;
            this.stateManager.set('pbData', pbData);
        }
    };
    CartContainer.prototype.scrolltoTop = function () {
        if (window) {
            window.scrollTo(0, 0);
        }
    };
    CartContainer.prototype.onCartEdit = function (lobtype) {
        if (lobtype) {
            this.stateManager.set('onEditCart', { onEditCart: lobtype });
        }
    };
    CartContainer.prototype.retriveModalClose = function () {
        this.setState({
            showRetrieveModal: false,
        });
    };
    CartContainer.prototype.getCmsErrorData = function (errorType, errors) {
        var error = errorType && errors && errors.length > 0 ? errors.find(function (err) { return (err && err.errorCode && err.errorCode.toLowerCase() === errorType.toLowerCase()); }) : null;
        return error || {};
    };
    CartContainer.prototype.acpAccessPromo = function () {
        var _a, _b, _c, _d;
        if (acpVerificationAccessPromo()) {
            return (React.createElement("div", { className: styles.acpPromoContainer },
                React.createElement(Alert, { onWhite: true, type: "error" },
                    React.createElement("span", { className: styles.acpPromoText }, (_d = (_c = (_b = (_a = this.cartCheckoutCMS) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.cart) === null || _c === void 0 ? void 0 : _c.core) === null || _d === void 0 ? void 0 : _d.acpEmptyCart))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    // tslint:disable-next-line:no-any
    CartContainer.prototype.fetchOnDeviceEncryptToken = function (targetIMEI) {
        var request = {
            source: 'EAP',
            ratePlanFlag: 'F',
            statusCodes: [
                { statusCode: '400',
                    statusTimestamp: (new Date()).toISOString(),
                    statusMessage: 'Session Timeout',
                },
            ],
            targetIMEI: targetIMEI,
        };
        var isEapEdsActivationEncrypttoken = isIxpCheckoutFeatureEnabled('svc-eap-eds-watchactivation-encrypttoken');
        var postEncryption = isEapEdsActivationEncrypttoken
            ? this.checkoutUiApi.postEdsEncriptionForActivationEAP(request)
            : this.cApi.postEdsEncriptionForActivation(request);
        return postEncryption.then(function (response) {
            console.log("postEncryptionResp", response);
            if (response && response.content) {
                return response.json();
            }
            else {
                return Promise.reject.bind(Promise);
            }
        }).then(function (result) {
            console.log('postEncryptionResp1', result);
            return result;
        }).catch(function (reason) {
            console.log('postEncryptionRespcatch', reason);
            Promise.reject(reason);
        });
    };
    CartContainer.prototype.eapCancelButtonHandler = function () {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function () {
            var wlsPostpaid, returnURL, targetIMEI, error_1;
            var _this = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        wlsPostpaid = JSON.parse(sessionStorage.getItem('wlsPostpaid'));
                        if (!(wlsPostpaid === null || wlsPostpaid === void 0 ? void 0 : wlsPostpaid.wsceData)) {
                            wlsPostpaid = JSON.parse(sessionStorage.getItem('CHECKOUT:wlsPostpaidAndroid'));
                        }
                        returnURL = ((_a = wlsPostpaid === null || wlsPostpaid === void 0 ? void 0 : wlsPostpaid.wsceData) === null || _a === void 0 ? void 0 : _a.eapFlow) && ((_c = (_b = wlsPostpaid === null || wlsPostpaid === void 0 ? void 0 : wlsPostpaid.wsceData) === null || _b === void 0 ? void 0 : _b.eapFlow) === null || _c === void 0 ? void 0 : _c.returnURL);
                        targetIMEI = ((_d = wlsPostpaid === null || wlsPostpaid === void 0 ? void 0 : wlsPostpaid.wsceData) === null || _d === void 0 ? void 0 : _d.eapFlow) && ((_f = (_e = wlsPostpaid === null || wlsPostpaid === void 0 ? void 0 : wlsPostpaid.wsceData) === null || _e === void 0 ? void 0 : _e.eapFlow) === null || _f === void 0 ? void 0 : _f.targetIMEI);
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fetchOnDeviceEncryptToken(targetIMEI)
                                .then(function (resp) { return __awaiter(_this, void 0, void 0, function () {
                                var formData, form, key, input;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    console.log('encryptionResp', resp);
                                    formData = {
                                        prToken: (_a = resp === null || resp === void 0 ? void 0 : resp.content) === null || _a === void 0 ? void 0 : _a.handoffToken,
                                        responseToken: (_b = resp === null || resp === void 0 ? void 0 : resp.content) === null || _b === void 0 ? void 0 : _b.responseToken,
                                    };
                                    form = document.createElement('form');
                                    form.method = 'POST';
                                    form.action = returnURL;
                                    for (key in formData) {
                                        input = document.createElement('input');
                                        input.name = key;
                                        input.value = formData[key];
                                        input.type = 'hidden';
                                        form.appendChild(input);
                                    }
                                    document.body.appendChild(form);
                                    form.submit();
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 2:
                        _g.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _g.sent();
                        console.log('encryptionRespcatch', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CartContainer.prototype.render = function () {
        var _a, _b, _c, _d;
        this.cartCheckoutCMS = CMS.get(new CartCoreCms(), 'cartcheckout');
        var coreCmsData = [];
        if (this.state.allowedCMSGetCall) {
            coreCmsData = ((_d = (_c = (_b = (_a = this.cartCheckoutCMS) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.cart) === null || _c === void 0 ? void 0 : _c.core) === null || _d === void 0 ? void 0 : _d.errors) ? this.cartCheckoutCMS.content.cart.core.errors : [];
        }
        if (this.state.loading || !this.state.allowedCMSGetCall) {
            return (React.createElement("div", { className: styles.cartLoaderShow },
                React.createElement(InfiniteLoader, null)));
        }
        else if (this.state.cartError) {
            var payload = cartUiUtils.getCartResp();
            var isFirstNetCustomer = payload && cartUtils.isFNIntentPresent();
            var notificationData = void 0;
            if (this.errorCode === 'CTLG-E500021' || this.errorCode === 'Service-I-1017') {
                this.errorCode = isFirstNetCustomer ? 'FirstNet-CTO' : this.errorCode;
                var error = this.getCmsErrorData(this.errorCode, coreCmsData) || {};
                notificationData = {
                    description: this.errorMessage || error.errorMessage,
                    primaryButtonLabel: error.primaryButtonLabel || 'Reload my cart',
                    secondaryButtonLabel: isFirstNetCustomer ? '' : error.secondaryButtonLabel || 'Start Over',
                    title: isFirstNetCustomer ? error.title : '',
                };
            }
            else {
                var error = isFirstNetCustomer ? this.getCmsErrorData('FirstNet-CTO', coreCmsData) :
                    this.getCmsErrorData('defult', coreCmsData);
                notificationData = {
                    description: error.errorMessage || "We weren't able to retrieve your cart items. Try to reload your cart. If the problem persists, please start over with your order.",
                    primaryButtonLabel: error.primaryButtonLabel || 'Reload my cart',
                    secondaryButtonLabel: isFirstNetCustomer ? '' : error.secondaryButtonLabel || 'Start over',
                    title: error.title || 'Uh-oh! Something went wrong.',
                };
            }
            return (React.createElement(RoutableContainer, null,
                (payload === null || payload === void 0 ? void 0 : payload.enablePrePreOrderView) && React.createElement(CartCheckoutCountDownTimer, null),
                this.renderOfferBanner(),
                this.getCartHeader(),
                this.acpAccessPromo(),
                React.createElement("div", { className: styles.rennyBtnr },
                    React.createElement(NotificationPanel, { data: notificationData, events: {
                            primaryButtonClick: this.reloadCartPage,
                            secondaryButtonClick: this.startShopping,
                        }, options: { type: NotificationType.CART_ERROR, accessibilityText: 'Shopping Cart Icon', styleType: 'renny' } })),
                React.createElement("div", { style: { marginBottom: '200px' } })));
        }
        else if (this.state.emptyCart) {
            sessionStorage.removeItem('byodCombinedResponse');
            sessionStorage.removeItem('byodResponses');
            if (this.state.showRetrieveModal) {
                // show the retrieve modal
                return (React.createElement(RoutableContainer, null,
                    this.renderOfferBanner(),
                    this.getCartHeader(),
                    this.acpAccessPromo(),
                    React.createElement(RetrieveCart, { data: { triggerCart: true }, events: { onModalClose: this.retriveModalClose } }),
                    React.createElement("div", { style: { marginBottom: '200px' } })));
            }
            else {
                var notificationData = void 0;
                if (this.errorCode === 'CTLG-E500028') {
                    var error = this.getCmsErrorData(this.errorCode, coreCmsData);
                    notificationData = {
                        description: this.errorMessage || error.errorMessage,
                        secondaryButtonLabel: error.secondaryButtonLabel || 'Start Over',
                        title: '',
                    };
                }
                else {
                    var error = this.getCmsErrorData('emptyCart', coreCmsData);
                    notificationData = {
                        description: '',
                        primaryBnotificationDatauttonLabel: (this.hideRetriveCartButton || this.state.hideRetriveCartLink) ? '' : error.primaryButtonLabel ||
                            'Retrieve Cart',
                        secondaryButtonLabel: error.secondaryButtonLabel || 'Start shopping',
                        title: error.title || 'Your shopping cart is empty.',
                    };
                }
                return (React.createElement(RoutableContainer, null,
                    this.renderOfferBanner(),
                    this.getCartHeader(),
                    this.acpAccessPromo(),
                    React.createElement("div", { className: styles.rennyBtnr },
                        React.createElement(NotificationPanel, { data: notificationData, events: {
                                primaryButtonClick: this.retrieveSavedCart,
                                secondaryButtonClick: this.startShopping,
                            }, options: { type: NotificationType.EMPTY_CART, accessibilityText: 'Shopping Cart Icon', styleType: 'renny' } })),
                    React.createElement("div", { style: { marginBottom: '200px' } })));
            }
        }
        else {
            return this.getCartConsole();
        }
    };
    CartContainer.prototype.getCartHeader = function (options) {
        var _a, _b, _c, _d;
        if (options === void 0) { options = { text: 'My cart', size: LabelSizes.HUGEHEADING }; }
        var text = ((_d = (_c = (_b = (_a = this.cartCheckoutCMS) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.cart) === null || _c === void 0 ? void 0 : _c.core) === null || _d === void 0 ? void 0 : _d.pageTitle) || options.text || 'My cart';
        var size = options.size || LabelSizes.HUGEHEADING;
        var unauthStyle = cartUiUtils.unauthenticatedAccess() ? styles.ifUnauthAccess : '';
        return (React.createElement("div", { className: [styles.appShellrwdw1, styles.baseStyles, styles.removeBefore, unauthStyle].join(' ') },
            React.createElement(Heading, { data: { text: text }, options: { size: size, className: styles.titleHeading, type: Types.H1 } })));
    };
    CartContainer.prototype.fireLinkClickEvent = function () {
        var _a, _b, _c, _d;
        var linkName = (_d = (_c = (_b = (_a = this.cartCheckoutCMS) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.cart) === null || _c === void 0 ? void 0 : _c.core) === null || _d === void 0 ? void 0 : _d.callToOrderMsg;
        var reportingDestinationURL = '/buy/cart';
        var addData = {
            additionalData: {
                linkDestinationUrl: location.origin + reportingDestinationURL,
                linkName: linkName,
                linkPosition: LinkPositionDataKeysOptions.BODY,
            },
            eventAction: 'linkClick',
            eventCode: 'Link_Click',
        };
        ReportingGateway.sendReportingEvent(addData);
    };
    CartContainer.prototype.CTOExperience = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        return (React.createElement("div", { className: [styles.appShellrwdw1, styles.baseStyles, styles.removeBefore, 'pad-b-none'].join(' ') },
            React.createElement("div", { className: styles.callToOrder + " pad-r-sm font-bold" },
                React.createElement("span", { "data-test-id": "toll-free-phone-icon", className: styles.callToOrderIconStyle },
                    React.createElement(IconSvg, { size: 16, svgNodeStr: (_d = (_c = (_b = (_a = this.cartCheckoutCMS) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.cart) === null || _c === void 0 ? void 0 : _c.core) === null || _d === void 0 ? void 0 : _d.callToOrderIcon })),
                React.createElement("span", { "data-test-id": "toll-free-content" }, (_h = (_g = (_f = (_e = this.cartCheckoutCMS) === null || _e === void 0 ? void 0 : _e.content) === null || _f === void 0 ? void 0 : _f.cart) === null || _g === void 0 ? void 0 : _g.core) === null || _h === void 0 ? void 0 : _h.callToOrderMsg),
                React.createElement("span", { "data-test-id": "toll-free-number", className: styles.callToOrderPhoneStyle, onClick: function () { return _this.fireLinkClickEvent(); } }, this.isMobileDevice() ? (React.createElement("a", { href: "tel://" + ((_m = (_l = (_k = (_j = this.cartCheckoutCMS) === null || _j === void 0 ? void 0 : _j.content) === null || _k === void 0 ? void 0 : _k.cart) === null || _l === void 0 ? void 0 : _l.core) === null || _m === void 0 ? void 0 : _m.callToOrderPhone) }, (_r = (_q = (_p = (_o = this.cartCheckoutCMS) === null || _o === void 0 ? void 0 : _o.content) === null || _p === void 0 ? void 0 : _p.cart) === null || _q === void 0 ? void 0 : _q.core) === null || _r === void 0 ? void 0 : _r.callToOrderPhone))
                    : (React.createElement("a", null, (_v = (_u = (_t = (_s = this.cartCheckoutCMS) === null || _s === void 0 ? void 0 : _s.content) === null || _t === void 0 ? void 0 : _t.cart) === null || _u === void 0 ? void 0 : _u.core) === null || _v === void 0 ? void 0 : _v.callToOrderPhone))))));
    };
    CartContainer.prototype.isMobileDevice = function () {
        return (window.innerWidth < 768);
    };
    CartContainer.prototype.setBannerMessages = function () {
        var _a, _b, _c;
        var couponDetails = this.stateManager.get('Bundles', 'couponInfo');
        var currentLobList = cartUiUtils.getCurrentLOBList();
        var displayCouponCode = false;
        var displayInstalltionMsg = false;
        var promoDescCMS = [];
        var hhCouponCode = '';
        this.setState({ bannerMessages: [] });
        if (currentLobList && currentLobList.length > 0) {
            displayCouponCode = this.displayHandholdingLob.some(function (ele) { return currentLobList.includes(ele); });
            displayInstalltionMsg = this.displayInstallationMsgLob.some(function (ele) { return currentLobList.includes(ele); });
        }
        promoDescCMS = ((_c = (_b = (_a = this.cartCheckoutCMS) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.common) === null || _c === void 0 ? void 0 : _c.handholdingCouponMessages) ? this.cartCheckoutCMS.content.common.handholdingCouponMessages : [];
        if (couponDetails && couponDetails.couponInfo && couponDetails.couponInfo.couponCode) {
            hhCouponCode = couponDetails.couponInfo.couponCode;
        }
        var hhCouponCMS = this.getHandholdingCouponMsgFromCMS(promoDescCMS, hhCouponCode);
        if (displayCouponCode && hhCouponCMS && hhCouponCMS.description) {
            this.setState({
                autoExpandPromoSection: true,
                bannerMessages: __spreadArrays(this.state.bannerMessages, [hhCouponCMS.description]),
            });
        }
        else if (displayInstalltionMsg) {
            this.getinstallationMessage();
        }
    };
    CartContainer.prototype.getHandholdingCouponMsgFromCMS = function (promoDescCMS, couponCode) {
        if (promoDescCMS && promoDescCMS.length > 0) {
            return promoDescCMS.find(function (promo) {
                return promo.code === couponCode;
            });
        }
    };
    CartContainer.prototype.clearCartSessionObject = function () {
        this.stateManager.remove('cartResponse');
    };
    CartContainer.prototype.getinstallationMessage = function () {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var installationMsgCMS, addressInfoObj, installationURL, response, installationData, error_2;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        installationMsgCMS = ((_c = (_b = (_a = this.cartCheckoutCMS) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.common) === null || _c === void 0 ? void 0 : _c.installationMessages) ? this.cartCheckoutCMS.content.common.installationMessages : {};
                        addressInfoObj = this.getCartAddressObj('DTVS');
                        installationURL = (!addressInfoObj.fullCKAVDone && addressInfoObj.cartZipCode) ?
                            this.installationOffersURL + '?zipcode=' + addressInfoObj.cartZipCode : this.installationOffersURL;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, networker.get(installationURL, { headers: cartUiUtils.getInitialHeaders() })];
                    case 2:
                        response = _d.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        installationData = _d.sent();
                        if (installationData && installationData.installationMessageKey &&
                            installationMsgCMS && installationMsgCMS[installationData.installationMessageKey]) {
                            this.setState({
                                autoExpandPromoSection: true,
                                bannerMessages: __spreadArrays(this.state.bannerMessages, [installationMsgCMS[installationData.installationMessageKey]]),
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _d.sent();
                        console.log('Service availability API Error');
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CartContainer.prototype.getCartAddressObj = function (lob) {
        var addressObj = {
            cartZipCode: '',
            fullCKAVDone: false,
        };
        var payload = cartUiUtils.getCartResp();
        var lobMetadataKey = (lob && typeof (lob) === 'string') ? lob.toLowerCase() + 'Metadata' : '';
        if (lobMetadataKey && payload.metadata && payload.metadata.metadata &&
            payload.metadata && payload.metadata.metadata[lobMetadataKey] &&
            payload.metadata.metadata[lobMetadataKey].addressId) {
            addressObj.fullCKAVDone = true;
        }
        if (payload && payload.zipCode) {
            addressObj.cartZipCode = payload.zipCode;
        }
        return addressObj;
    };
    CartContainer.prototype.getBannerContainer = function () {
        var isUnauthAccess = cartUiUtils.unauthenticatedAccess();
        if (isUnauthAccess) {
            return (React.createElement(React.Fragment, null));
        }
        else {
            var banner_1 = [];
            if (this.state.bannerMessages && this.state.bannerMessages.length > 0) {
                this.state.bannerMessages.forEach(function (message, index) {
                    banner_1.push(React.createElement(Banner, { data: {
                            desktopText: message,
                            mobileText: message,
                        }, testId: "bannerMsg_" + index, key: index }));
                });
            }
            return (banner_1.concat());
        }
    };
    CartContainer.prototype.setStartShoppingURL = function () {
        var payload = cartUiUtils.getCartResp();
        var firstLobItem = cartUiUtils.getCurrentLOB();
        if (payload && firstLobItem) {
            var metadataKey = cartUtils.lobCartKeys.get(firstLobItem) ? cartUtils.lobCartKeys.get(firstLobItem).metadata : null;
            if (metadataKey && payload.metadata && payload.metadata.metadata && payload.metadata.metadata[metadataKey] &&
                payload.metadata.metadata[metadataKey].editUrl) {
                this.stateManager.set('startShoppingURL', { startShoppingURL: payload.metadata.metadata[metadataKey].editUrl });
            }
            else {
                var isCommonCart = (payload && payload.commonCart) ? true : false;
                var bsseUrl = '/buy/wireless/byod';
                if (isCommonCart) {
                    this.stateManager.set('startShoppingURL', { startShoppingURL: bsseUrl });
                }
            }
        }
    };
    CartContainer.prototype.setupCloserCouponEvents = function () {
        var _a, _b, _c;
        var currentLobList = cartUiUtils.getCurrentLOBList();
        var postpaidflowtype = getPostpaidflowtype();
        var getWirelineTriggerEvents = false;
        var getWirlessTriggerEvents = false;
        var userInteractionSetupCMSObj;
        var readPrepaidSetUpData = !!this.isPrepaidFlow();
        if (currentLobList && currentLobList.length > 0) {
            getWirelineTriggerEvents = this.closerCouponWirelineLobs.some(function (ele) { return currentLobList.includes(ele); });
            getWirlessTriggerEvents = this.closerCouponWirelessLobs.some(function (ele) { return currentLobList.includes(ele); });
        }
        if ((_c = (_b = (_a = this.cartCheckoutCMS) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.cart) === null || _c === void 0 ? void 0 : _c.userInteractionEvents) {
            if (getWirelineTriggerEvents && this.cartCheckoutCMS.content.cart.userInteractionEvents.wirelineUserInteractionEvents &&
                this.cartCheckoutCMS.content.cart.userInteractionEvents.wirelineUserInteractionEvents.userInteractionsMasterKey) {
                userInteractionSetupCMSObj = this.cartCheckoutCMS.content.cart.userInteractionEvents.wirelineUserInteractionEvents;
            }
            if (getWirlessTriggerEvents && !readPrepaidSetUpData && postpaidflowtype !== 'UP' && postpaidflowtype !== 'AL' && this.cartCheckoutCMS.content.cart.userInteractionEvents.wirelessUserInteractionEvents &&
                this.cartCheckoutCMS.content.cart.userInteractionEvents.wirelessUserInteractionEvents.userInteractionsMasterKey) {
                userInteractionSetupCMSObj = this.cartCheckoutCMS.content.cart.userInteractionEvents.wirelessUserInteractionEvents;
            }
            if (getWirlessTriggerEvents && !readPrepaidSetUpData && postpaidflowtype === 'UP' && this.cartCheckoutCMS.content.cart.userInteractionEvents.upgradeUserInteractionEvents &&
                this.cartCheckoutCMS.content.cart.userInteractionEvents.upgradeUserInteractionEvents.userInteractionsMasterKey) {
                userInteractionSetupCMSObj = this.cartCheckoutCMS.content.cart.userInteractionEvents.upgradeUserInteractionEvents;
            }
            if (getWirlessTriggerEvents && !readPrepaidSetUpData && postpaidflowtype === 'AL' && this.cartCheckoutCMS.content.cart.userInteractionEvents.addalineUserInteractionEvents &&
                this.cartCheckoutCMS.content.cart.userInteractionEvents.addalineUserInteractionEvents.userInteractionsMasterKey) {
                userInteractionSetupCMSObj = this.cartCheckoutCMS.content.cart.userInteractionEvents.addalineUserInteractionEvents;
            }
            if (getWirlessTriggerEvents && readPrepaidSetUpData && this.cartCheckoutCMS.content.cart.userInteractionEvents.prepaidUserInteractionEvents &&
                this.cartCheckoutCMS.content.cart.userInteractionEvents.prepaidUserInteractionEvents.userInteractionsMasterKey) {
                userInteractionSetupCMSObj = this.cartCheckoutCMS.content.cart.userInteractionEvents.prepaidUserInteractionEvents;
            }
        }
        if (userInteractionSetupCMSObj && userInteractionSetupCMSObj.userInteractionsMasterKey) {
            userinteractionEvents.setupUserInteraction(userInteractionSetupCMSObj);
        }
    };
    CartContainer.prototype.renderLoginPanel = function () {
        var redirectionURL = cartUiUtils.isLoginRequiredonCart() ? cartUiUtils.getauthenticatedPersistantLoginURL() : '';
        var isPrePreOrder = cartUtils.isPrePreOrder();
        return (React.createElement(React.Fragment, null, !isPrePreOrder &&
            React.createElement("div", { className: styles.loginPanelContainer },
                React.createElement(LoginPanel, { data: {
                        redirectToLoginURL: redirectionURL,
                        sisfoDisplayText: '',
                    } }))));
    };
    CartContainer.prototype.renderOfferBanner = function () {
        var isUnauthAccess = cartUiUtils.unauthenticatedAccess();
        if (isUnauthAccess) {
            return (React.createElement(React.Fragment, null));
        }
        else {
            return (React.createElement("div", { className: styles.offerbanner },
                React.createElement(FanBanner, null)));
        }
    };
    CartContainer.prototype.getCartConsole = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var payload = cartUiUtils.getCartResp();
        // tslint:disable-next-line:no-any
        var showOnDeviceWearablePPU = this.stateManager.get('CHECKOUT', 'showOnDeviceWearablePPU');
        return (React.createElement(React.Fragment, null,
            React.createElement(RoutableContainer, null,
                (payload === null || payload === void 0 ? void 0 : payload.enablePrePreOrderView) && React.createElement(CartCheckoutCountDownTimer, null),
                !this.state.isExpressCart && this.renderOfferBanner(),
                this.getBannerContainer(),
                this.renderLoginPanel(),
                cartUiUtils.getIXPValue('svc-cart-display-need-help') && this.isBBOnlyInCart && ((_d = (_c = (_b = (_a = this.cartCheckoutCMS) === null || _a === void 0 ? void 0 : _a.content) === null || _b === void 0 ? void 0 : _b.cart) === null || _c === void 0 ? void 0 : _c.core) === null || _d === void 0 ? void 0 : _d.callToOrderPhone) && this.CTOExperience(),
                this.getCartHeader(),
                this.isErrorCode &&
                    React.createElement(Message, { testId: getTestId('Message', 'priceInfo_Error_Message'), data: {
                            type: MessageType.ERROR,
                        }, options: { closeButton: this.showCloseButton() } },
                        React.createElement("div", null,
                            React.createElement("span", { className: styles.errorMsgStyle }, this.errorMessage)),
                        React.createElement("div", null,
                            React.createElement("a", { href: this.getHrefUrl() }, "Continue Shopping"))),
                !this.state.isExpressCart &&
                    React.createElement(CartConfigurationContainer, { data: {}, options: {
                            autoExpandPromoSection: this.state.autoExpandPromoSection,
                            collapseCart: false,
                            displayCartInCollapsedState: false,
                            showAdvertisementPanel: false,
                            showBundlesTreatment: false,
                            showCloserCoupons: true,
                            showFutureBillEstimator: true,
                            showSisfoLoginPanel: true,
                            triggerReportingEvents: {
                                triggerCartDisplaySystemEvent: true,
                                triggerCartPageLoad: true,
                            },
                        }, events: {
                            onEdit: function (lobType) {
                                _this.updatePriceBarData(true);
                            },
                        } })),
            React.createElement(SessionTimerModal, { data: { redirectURL: '/buy/cart/?retrievecart=true' }, events: {
                    onApiFailure: function () {
                        _this.cApi.logToSplunk({ data: 'SKA Call failed, hence not able to extend the session', hdrReasonCode: 'SKA_CALL_FAILURE', type: 'TIMEOUT' });
                    },
                    onExpiryModalDisplay: function (txt) {
                        _this.cApi.logToSplunk({ data: txt, hdrReasonCode: 'FE_SESSION_TIMED_OUT', type: 'TIMEOUT' });
                    },
                    onContinueCTAClick: function () {
                        _this.cApi.logToSplunk({ data: 'session expire continue CTA clicked', hdrReasonCode: 'FE_SESSION_TIMED_OUT', type: 'TIMEOUT' });
                        if (!!(showOnDeviceWearablePPU === null || showOnDeviceWearablePPU === void 0 ? void 0 : showOnDeviceWearablePPU.isWearable)) {
                            _this.eapCancelButtonHandler();
                        }
                    },
                    onExpireCTAClick: function () {
                        _this.cApi.logToSplunk({ data: 'session expire cancel CTA clicked', hdrReasonCode: 'FE_SESSION_TIMED_OUT', type: 'TIMEOUT' });
                        if (!!(showOnDeviceWearablePPU === null || showOnDeviceWearablePPU === void 0 ? void 0 : showOnDeviceWearablePPU.isWearable)) {
                            _this.eapCancelButtonHandler();
                        }
                    },
                } })));
    };
    CartContainer.prototype.showCloseButton = function () {
        var url = this.props.baseURL ? this.props.baseURL.url : '';
        return url.indexOf(RouteUrlTypes.DTVNOW) === -1;
    };
    CartContainer.prototype.getHrefUrl = function () {
        var baseUrl = this.props.baseURL && this.props.baseURL.url ? this.props.baseURL.url : '';
        if (baseUrl.indexOf(RouteUrlTypes.DIRECTV)) {
            return RouteUrlTypes.DIRECTV;
        }
        else if (baseUrl.indexOf(RouteUrlTypes.BROADBAND)) {
            return RouteUrlTypes.BROADBAND;
        }
        else if (baseUrl.indexOf(RouteUrlTypes.IPTV)) {
            return RouteUrlTypes.IPTV;
        }
        else if (baseUrl.indexOf(RouteUrlTypes.PREPAID)) {
            return RouteUrlTypes.PREPAID;
        }
        else if (baseUrl.indexOf(RouteUrlTypes.WIRELESSINTERSTITIAL)) {
            return RouteUrlTypes.WIRELESSINTERSTITIAL;
        }
        else if (baseUrl.indexOf(RouteUrlTypes.WIRELESS)) {
            return RouteUrlTypes.WIRELESS;
        }
        else if (baseUrl.indexOf(RouteUrlTypes.OFFERS)) {
            return RouteUrlTypes.OFFERS;
        }
        else if (baseUrl.indexOf(RouteUrlTypes.BUNDLE)) {
            return RouteUrlTypes.BUNDLE;
        }
    };
    CartContainer.prototype.cartSummary = function (isRefresh) {
        var _this = this;
        this.getCartInfo();
        this.setState({ loading: true, cartError: false });
        networker.get(this.bsseSummaryURL, { headers: cartUiUtils.getInitialHeaders() })
            .then(rejectHTTPErrors)
            .then(function (res) { return parseJSON(res); })
            .then(function (data) {
            var _a, _b, _c, _d;
            _this.stateManager.set('cartResponse', data);
            if (((_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.wirelessCart) === null || _c === void 0 ? void 0 : _c._cartPageurl) === null || _d === void 0 ? void 0 : _d.indexOf('shoppingcart')) > -1) {
                window.location.href = '/buy/shoppingcart?flowtype=wireless';
            }
            else {
                _this.onCartSuccessResponse(data, isRefresh);
            }
        }).catch(function (err) {
            console.error('cart data failed! ', err);
            _this.setState({
                loading: false,
            });
        });
    };
    CartContainer.prototype.checkExpressUpFlow = function (payload) {
        var _a;
        if (payload === null || payload === void 0 ? void 0 : payload.enableExpupgradeView) {
            this.stateManager.set('isExpViewExpanded', { isViewExpanded: (getUrlParamValue('expandedview', location.href) || getUrlParamValue('expandedView', location.href)) });
            this.updatePriceBarData(false);
            if (!isIncompleteCart(payload) && !(payload === null || payload === void 0 ? void 0 : payload.requiredLogin) && !isItemOOS(payload) &&
                !isAtleastOneLineLevelPrePreOrderIndicator(payload) && ((_a = payload === null || payload === void 0 ? void 0 : payload.cartStatus) === null || _a === void 0 ? void 0 : _a.readyToCheckout)) {
                var sourceparam = getUrlParamValue('source', location.href);
                if (sourceparam) {
                    history.push('/checkout/cartview/?source=' + sourceparam);
                }
                else {
                    history.push('/checkout/cartview');
                }
            }
        }
    };
    CartContainer.prototype.setUpgradeIntent = function () {
        var intentValue = { wirelessIntent: 'up' };
        if (cartUiUtils.checkQueryParameter('wlsfi=up')) {
            this.stateManager.set('IDSEIntent', intentValue);
            this.cApi.getUserCurrentState().then(function () {
                console.log('response success');
            }).catch(function (err) {
                console.log('Error in getting response');
            });
        }
    };
    CartContainer.prototype.onCartSuccessResponse = function (data, isRefresh) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        var isExpressCart = false;
        this.isBBOnlyInCart = cartUiUtils.IsBroadbandInCart();
        this.checkExpressUpFlow((_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.payload);
        this.getCampaignId((_b = data === null || data === void 0 ? void 0 : data.content) === null || _b === void 0 ? void 0 : _b.payload);
        setCookie('idp-source', getCartMetaFlowType((_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.content) === null || _c === void 0 ? void 0 : _c.payload) === null || _d === void 0 ? void 0 : _d.metadata) === null || _e === void 0 ? void 0 : _e.metadata));
        this.setStartShoppingURL();
        if (data && data.error && data.error.errorId) {
            if (data.error.errorId === 'Service-I-1017') {
                this.errorCode = data.error.errorId;
                this.errorMessage = "Uh-oh! Something went wrong. We weren't able to retrieve your cart items. Try to reload your cart. If the problem persists, please start over with your order.";
                this.reportingErrorMessage = this.errorMessage;
                this.setState({ cartError: true });
                this.scrolltoTop();
                setCookie('idp-source', '', -1);
                reportPageLoad(true, 'Service-I-1017');
            }
            else if (data.error.errorId === 'Cart-IO-MIN-SPEED-0001') {
                history.push('/bundles');
            }
            else {
                this.errorCode = data.error.errorId;
                this.reportingErrorMessage = "API failure response";
                reportPageLoad(true, 'API-Failed');
            }
        }
        if (((_f = data === null || data === void 0 ? void 0 : data.content) === null || _f === void 0 ? void 0 : _f.payload) && (((_g = data.content.payload) === null || _g === void 0 ? void 0 : _g.metadata) || ((_h = data.content.payload) === null || _h === void 0 ? void 0 : _h.commonCart))) {
            this.isErrorCode = false;
            if (data.content.payload.commonCart && data.content.payload.commonCart.cartStatus) {
                data.content.payload.cartStatus = data.content.payload.commonCart.cartStatus;
            }
            if ((_l = (_k = (_j = data === null || data === void 0 ? void 0 : data.content) === null || _j === void 0 ? void 0 : _j.payload) === null || _k === void 0 ? void 0 : _k.cartStatus) === null || _l === void 0 ? void 0 : _l.readyToCheckout) {
                this.checkAcpEligibility("BROADBAND");
            }
            if (((_o = (_m = data === null || data === void 0 ? void 0 : data.content) === null || _m === void 0 ? void 0 : _m.payload) === null || _o === void 0 ? void 0 : _o.enableExpupgradeView) && ((_r = (_q = (_p = data === null || data === void 0 ? void 0 : data.content) === null || _p === void 0 ? void 0 : _p.payload) === null || _q === void 0 ? void 0 : _q.cartStatus) === null || _r === void 0 ? void 0 : _r.readyToCheckout)
                && !((_t = (_s = data === null || data === void 0 ? void 0 : data.content) === null || _s === void 0 ? void 0 : _s.payload) === null || _t === void 0 ? void 0 : _t.requiredLogin) && !isItemOOS((_u = data === null || data === void 0 ? void 0 : data.content) === null || _u === void 0 ? void 0 : _u.payload)) {
                isExpressCart = true;
                this.setState(function () { return ({
                    data: data,
                    emptyCart: false,
                    isExpressCart: true,
                    loading: false,
                }); });
            }
            else {
                this.setState(function () { return ({
                    data: data,
                    emptyCart: false,
                    loading: false,
                }); });
            }
            if (data.content.payload.orderPriceInfo &&
                data.content.payload.orderPriceInfo.dueToday &&
                data.content.payload.orderPriceInfo.dueMonthly) {
                var dueOneTimePrice = data.content.payload.orderPriceInfo.dueOneTime;
                if (dueOneTimePrice === 0 && data.content.payload.dtvsCart) {
                    dueOneTimePrice = data.content.payload.dtvsCart.totalLob1stBill || 0;
                }
                this.stateManager.set('priceBarUpdate', {
                    dueMonthly: data.content.payload.orderPriceInfo.dueMonthly,
                    dueOneTime: dueOneTimePrice,
                    dueToday: data.content.payload.orderPriceInfo.dueToday,
                    readyToCheckout: isExpressCart ? false : data.content.payload.cartStatus.readyToCheckout,
                });
            }
        }
        else {
            this.setState(function () { return ({
                data: data,
                emptyCart: true,
                hideRetriveCartLink: data && data.content &&
                    data.content.payload && data.content.payload.authUser ? true : false,
                loading: false,
            }); });
            this.stateManager.set('priceBarUpdate', {
                dueMonthly: 0,
                dueOneTime: 0,
                dueToday: 0,
                readyToCheckout: false,
            });
            this.scrolltoTop();
            if (isRefresh && this.state.emptyCart) {
                reportPageLoad(false);
            }
            else if (this.state.emptyCart) {
                reportPageLoad(true, 'empty-cart');
            }
        }
        this.setState({ loading: false });
        this.setBannerMessages();
        if (!isRefresh && !this.state.cartError && !this.state.emptyCart) {
            this.setupCloserCouponEvents();
        }
        window.scroll(window.pageXOffset, window.pageYOffset + 1);
    };
    CartContainer.prototype.getCampaignId = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var productCatagory, productSKUs, campaignId, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!(IsWirelessInCart(payload) && (payload === null || payload === void 0 ? void 0 : payload.enableCartCampaignId))) return [3 /*break*/, 2];
                        productCatagory = 'Wireless';
                        productSKUs = cartUiUtils.getProductSKUs(payload);
                        return [4 /*yield*/, getCampaignIdentifier(productSKUs, productCatagory)];
                    case 1:
                        campaignId = _a.sent();
                        if (campaignId) {
                            this.stateManager.set('campaignId', { value: campaignId });
                        }
                        else {
                            this.stateManager.remove('campaignId');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        this.stateManager.remove('campaignId');
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_3 = _a.sent();
                        console.log('Error in Camapign Id' + error_3);
                        this.stateManager.remove('campaignId');
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CartContainer.prototype.invokeMigrateCartApi = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var response, migrateCartResponse, error_4;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, networker.post(this.migrateCartApi, {}, { headers: cartUiUtils.getInitialHeaders() })];
                    case 1:
                        response = _c.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        migrateCartResponse = _c.sent();
                        if (((_b = (_a = migrateCartResponse === null || migrateCartResponse === void 0 ? void 0 : migrateCartResponse.content) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'SUCCESS') {
                            networker.get(this.initializeCartApi, { headers: cartUiUtils.getInitialHeaders() }).then(function (data) {
                                _this.cartSummary(true);
                            }).catch(function (error) {
                                console.log('Error in Initialize cart' + error);
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _c.sent();
                        console.log('Error in Migrate Cart Response' + error_4);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CartContainer.prototype.buildRepriceCartPayload = function (acpTransactionId, serviceType, productGroup) {
        var _a;
        var sessionId = this.stateManager.get('appShell', 'sid');
        var repriceCartPayload = {
            serviceContext: {
                sessionKey: (_a = sessionId === null || sessionId === void 0 ? void 0 : sessionId.value) !== null && _a !== void 0 ? _a : '',
                srcSystem: 'IDSE',
            },
            shoppingContext: {
                acpEligibility: {
                    serviceType: serviceType,
                    transactionId: acpTransactionId,
                },
                productGroups: [productGroup],
            },
        };
        return repriceCartPayload;
    };
    CartContainer.prototype.checkAcpEligibility = function (productGroup) {
        var _this = this;
        if (cartUiUtils.IsBroadbandInCart() && !cartUtils.isAcpSystemError()) {
            var acpEligibilityPromoInCS = cartUtils.getAcpEligibilityPromo();
            // If acpEligibility promo is not in cartSummary, then get the acpCustomerStatus from session storage,
            // then use acpCustomerStatus and make the repriceCart api call and on success, refresh the cartSummary.
            if (!acpEligibilityPromoInCS) {
                var acpCustomerStatus = cartUtils.getAcpCustomerStatusFromSessionStorage();
                var _a = acpCustomerStatus || {}, eligibilityIndicator = _a.eligibilityIndicator, acpTransactionId = _a.acpTransactionId, serviceType = _a.serviceType;
                if (eligibilityIndicator === true && acpTransactionId && serviceType) {
                    this.setState({ loading: true });
                    var repriceCartPayload = this.buildRepriceCartPayload(acpTransactionId, serviceType, productGroup);
                    this.cApi.repriceCart(repriceCartPayload).then(function (data) {
                        var _a, _b, _c;
                        _this.setState({ loading: false });
                        if (((_b = (_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'SUCCESS' &&
                            !isEmptyObject((_c = data === null || data === void 0 ? void 0 : data.content) === null || _c === void 0 ? void 0 : _c.payload)) {
                            _this.cartSummary(true);
                            cartUtils.removeAcpCustomerStatusFromSessionStorage();
                        }
                    }).catch(function (error) {
                        _this.setState({ loading: false });
                        console.log("ERROR: returned from repriceCart call: " + error);
                    });
                }
            }
        }
    };
    return CartContainer;
}(React.Component));
export { CartContainer };
var mapStateToProps = function (state) {
    if (state && state.appShell) {
        return {
            baseURL: state.appShell.baseURL,
            baseURLBB: state.appShell.baseURLBB,
            baseURLDTV: state.appShell.baseURLDTV,
            baseURLDTVS: state.appShell.baseURLDTVS,
            baseURLWLS: state.appShell.baseURLWLS,
            pbData: state.appShell.pbData,
        };
    }
    return {};
};
var CartContainerWithStore = withStore(mapStateToProps)(CartContainer);
export default CartContainerWithStore;
//# sourceMappingURL=Cart.container.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/Cart/Cart.container.js
// module id = 2237
// module chunks = 8